// --------------------------------
// Copyright (c) 2023 Eco8 S.r.l.
// --------------------------------
import { StyleSheet } from 'react-native';
import colors from '../../config/colors';
import fonts from '../../config/fonts';
const DataPickerStyle = StyleSheet.create({
    button: {
        flexDirection: 'row',
        alignItems: 'center',
        borderRadius: 10,
        justifyContent: 'center',
      },
      buttonText: {
        marginLeft: 10,
        color: colors.green,
        fontFamily: fonts.regular,
        fontSize:25,
        paddingVertical:5,
        fontWeight:'bold'
      },
      modalContainer: {
        position: 'relative',
        bottom: 0,
        left: 0,
        right: 0,
        top: 0,
        zIndex: 1500,
        width:195
      },
      modalBackground: {
        backgroundColor: 'white',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
      },
      modalOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0,0,0,0.5)',
      },
      calendarContainer: {
        backgroundColor: colors.white,
        shadowColor: colors.black,
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 0.5,
        shadowRadius: 4,
        elevation: 5,
        fontFamily: fonts.regular,
      },
});

export default DataPickerStyle;
